import { render } from "./EmailWizard.vue?vue&type=template&id=2d69148e"
import script from "./EmailWizard.vue?vue&type=script&lang=js"
export * from "./EmailWizard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__